<template>
  <div style="overflow-y: auto">
    <van-tabs v-model="activeName">
      <van-tab title="Tab 1" name="1">
        <!-- 内容 1 -->
      </van-tab>
      <van-tab title="Tab 2" name="2">
        <!-- 内容 2 -->
      </van-tab>
      <!-- 更多 Tab -->
    </van-tabs>
    <!-- <van-anchor :scroll-offset="50" @select="onSelect">
      <van-anchor-link title="Tab 1" href="#1" />
      <van-anchor-link title="Tab 2" href="#2" />
    </van-anchor> -->
    <van-index-bar style="height: 100vh" :sticky-offset-top="number">
      <van-index-anchor index="A" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />

      <van-index-anchor index="B" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-index-anchor index="C" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-cell title="文本" />
      <van-index-anchor index="S" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
      <van-cell title="文本1" />
    </van-index-bar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "1",
      number: 50,
    };
  },
  methods: {
    onSelect(link) {
      this.activeName = link.index;
      // 滚动到对应的Tab内容区域
      location.href = link.href;
    },
  },
};
</script>

<style scoped>
/deep/ .van-index-bar__sidebar {
  position: fixed;
  top: 3%;
  /* right: 0; */
  z-index: 2;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: row;
  text-align: center;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
  -webkit-user-select: none;
}
/deep/ .van-index-bar__index {
  padding: 0 3px;
}
</style>
